// extracted by mini-css-extract-plugin
export default {"container":"InvestmentGridHeader_container__h4NSZ","title":"InvestmentGridHeader_title__qhu63","disabled":"InvestmentGridHeader_disabled__YQDak"};